import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * 301 Redirect page for /study-verse/ -> /studyverse/
 * This page includes proper SEO signals for search engines:
 * - Canonical URL pointing to /studyverse/
 * - Meta refresh redirect
 * - noindex to prevent indexing
 * - JavaScript redirect for browsers
 */
const StudyVerseRedirect = () => {
  useEffect(() => {
    // Client-side redirect
    window.location.replace("/studyverse/");
  }, []);

  return (
    <>
      <Helmet>
        <title>Redirecting to Studyverse | CSW</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://csw.live/studyverse/" />
        <meta httpEquiv="refresh" content="0;url=/studyverse/" />
        {/* Add HTTP status hint for crawlers */}
        <meta name="prerender-status-code" content="301" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-muted-foreground">Redirecting to Studyverse...</p>
          <a href="/studyverse/" className="text-primary hover:underline mt-2 block">
            Click here if not redirected
          </a>
        </div>
      </div>
    </>
  );
};

export default StudyVerseRedirect;
